import CartRow from "../UI/Cart/CartRow"
import {withRouter} from "react-router-dom"
import {connect} from "react-redux"
import React,{useEffect, useState} from "react";
import * as actions from "../../store/actions/index"
import Spinner from "../Spinner/Spinner";
import CartSummary from "../UI/Cart/CartSummary";

const Cart = (props) => {
  
    const [isCartEmpty,setCartStatus] = useState(false);
   
useEffect(()=>{
    setCartStatus(false)
    if(props.user){
        
        props.onFetchCartProducts(props.user) 
       }else{ 
           
           
        //    setTimeout(()=>{
        //         if(!props.user){
        //             setCartStatus(true)
        //         }
        //    },2000) 
       }
      
},[props.isAuthenticated])


    if(props.cartProductsLoading){
        return <Spinner/>
    }
 

    if(props.cartProducts){
        if(!props.cartProducts.length){
            return(
                <div className="text-center" style={{marginTop:"5rem"}}>
                    <h5>Cart is Empty</h5> 
                </div>
            ) 
        }
    } 
    if(isCartEmpty){
        return <h5>Cart is Empty</h5>
    } 
    // console.log(props.cartProducts)
    return (    
        <> 
           {/* {isCartEmpty&&( <div>
                <h5>Cart is Empty</h5>
            </div>)} */}
            <div className="container" style={{ padding: "20px" }}>
               {props.cartProducts?( <section>
                   <div> 

                   {/* key={product.variantId?product.variantId:product.id} */} 

                   </div> 
                    <div className="row">

                        <div className="col-sm-12 col-lg-8">
 
                            {props.cartProducts.map((product,index)=>(
                                <CartRow key={Math.random()*1000} product={product} />
                            ))} 
                            {props.outOfStockProducts.map(op=>(
                                <CartRow key={op.variantId?op.variantId:op.id} product={op} />
                            ))} 
                        </div>  
                        <div className="col-lg-4">
                                <CartSummary products={props.cartProducts} order={props.order}/>

                        </div>

                    </div>

                </section>):null}
            </div>
        </> 
    ); 
};

const mapStateToProps = state=>{
    return{
        order:state.cart.order,
        cartProducts:state.cart.cartProducts,
        outOfStockProducts:state.cart.outOfStockProducts,
        cartLoading:state.cart.loading,
        cartProductsLoading:state.cart.cartProductsLoading,
        user: state.auth.user,
        isAuthenticated:state.auth.userId!=null
    }
}
const mapDispatchToProps = dispatch=>{
    return{
        onFetchCartProducts:(products)=>dispatch(actions.fetchCartProducts(products))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Cart)); 